module.exports = "../../static/img/chrismast.928b8a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chrismast.png
// module id = 371
// module chunks = 0